import { Typography, Link, Box } from "@mui/material";
import { API_ENDPOINTS } from "constants";
import { useAuthentication, useRestaurantByUserId } from "hooks";

export function BottomNavbar(props) {
  const { isAuthenticated, user } = useAuthentication();
  const { restaurant } = useRestaurantByUserId(user?.uid);

  const hasRestaurant = restaurant && restaurant.id;

  return (
    <Box sx={{ mt: 6, textAlign: "center" }} {...props}>
      {/* Business Links Section */}
      <Box sx={{ mb: 2 }}>
        {isAuthenticated && hasRestaurant ? (
          <>
            <Link 
              href={`/restaurant/${restaurant.id}`}
              color="primary" 
              sx={{ 
                textDecoration: 'none',
                fontWeight: 'medium',
                '&:hover': {
                  textDecoration: 'underline'
                }
              }}
            >
              Go to restaurant
            </Link>
            <Typography component="span" sx={{ mx: 2, color: 'text.secondary' }}>
              |
            </Typography>
            <Link 
              href={API_ENDPOINTS.VENDOR.HOME}
              color="inherit" 
              sx={{ 
                textDecoration: 'none',
                '&:hover': {
                  textDecoration: 'underline'
                }
              }}
            >
              Go to dashboard
            </Link>
          </>
        ) : (
          <>
            <Link 
              href={API_ENDPOINTS.VENDOR.BUSINESS_NEW} 
              color="primary" 
              sx={{ 
                textDecoration: 'none',
                fontWeight: 'medium',
                '&:hover': {
                  textDecoration: 'underline'
                }
              }}
            >
              Add your business
            </Link>
            {!isAuthenticated && (
              <>
                <Typography component="span" sx={{ mx: 2, color: 'text.secondary' }}>
                  |
                </Typography>
                <Link 
                  href={API_ENDPOINTS.VENDOR.HOME} 
                  color="inherit" 
                  sx={{ 
                    textDecoration: 'none',
                    '&:hover': {
                      textDecoration: 'underline'
                    }
                  }}
                >
                  Business sign in
                </Link>
              </>
            )}
          </>
        )}
      </Box>
      
      {/* Copyright Section */}
      <Typography
        variant="body2"
        color="text.secondary"
        align="center"
      >
        {"Copyright © "}
        <Link color="inherit" href={process.env.REACT_APP_MAIN_URL}>
          {process.env.REACT_APP_NAME}
        </Link>{" "}
        {new Date().getFullYear()}
        {"."}
      </Typography>
    </Box>
  );
}